<template>
  <div class="show_button" @click="showButton">
    <pt-icon type="icon-zengjia" :style="text?'margin-right: 5px;':''"></pt-icon>{{text}}
  </div>

</template>

<script>
  export default {
    name: 'addTag',
    props:{
      text:{
        type:String,
        default:''
      }
    },
    methods:{
      showButton(){
        this.$emit('showButton')
      }
    }
  }
</script>

<style scoped lang="less">
  .show_button{
    cursor: pointer;
    /*width: 90px;*/
    height: 25px;
    line-height: 25px;
    display: inline-block;
    padding:0 10px;
    background: #E8E8E8;
    border: 1px solid #DFDFDF;
    border-radius: 2px;
    font-size: 12px;
    color: #666666;
  }
</style>